<span class="tag {{tp}}"
    [class.primary]="isPrimary"
    [class.secondary]="isSecondary"
    (click)='switch($event)'>
    <span class='number'>{{number}}</span>
    <span [innerHTML]='name'></span>
  </span>
